import { useTheme } from '@emotion/react';
import LogoutIcon from '@mui/icons-material/Logout';
import { AppBar, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField, useMediaQuery } from '@mui/material';
import Toolbar from '@mui/material/Toolbar';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { debounce } from 'throttle-debounce';
import { IncubatorCycleTable } from '../../AppGrid/IncubatorCycleDetailTable';
import strings from '../../Globalization/index';
import { listIncubatorCycleDetailPending } from '../../actions/index';
import consts from '../../consts';
import { usePrerequisites } from '../../contexts/Prerequisites';
import connectionService from '../../services/Connection';
import STERISLogoPng from '../../styles/img/STERIS-Logo.png';
import connectassurePng from '../../styles/img/connectassure.png';
import util from '../../util/index';

const IncubatorCycleDetailTable = IncubatorCycleTable.createGridBase();

const TopHeader = () => {
	const navigate = useNavigate();
	const [, { logoutUser }] = usePrerequisites();
	const location = useLocation();
	const [state, setState] = useState({
		openPopUp: false,
		lotNumber: '',
		GTIN: '',
		oldGTIN: '',
		seletedRow: {}

	})
	const [searchParams] = useSearchParams();
	const id = searchParams.get('id') || 0;
	const cycleId = searchParams.get('cycleId') || 0;
	const incubatorCycleId = searchParams.get('incubatorCycleId') || 0;
	const incubatorId = searchParams.get('incubatorId') || 0;

	const parseData = util.localData.loginData;
	const { tags = {} } = parseData;
	const isAdminOrViewer= consts.regex.AdminOrViewer.test(tags.RoleName);
	const loginData = parseData ? parseData.tags : { HospitalName: strings.HospitalName, HospitalLogo: STERISLogoPng, DefaultLanguage: 'en' };
	const hospitalLogo = loginData?.HospitalLogo;
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
	let isCatViewer = util.isLicenseType('catviewer');
	const onGTINChange = (e) => {
		const barcodeScanValue = e.target.value;
		e.target.value = '';
		if (!barcodeScanValue.trim()) return;
		processBarcodeDetail(barcodeScanValue);
	};

	const processBarcodeDetail = (value) => {
		const parseData = util.localData.loginData;
		let lotNumber = '';
		let gtnValue = '';
		if (!parseData) return;

		const barcodeScanValue = value;
		let scannedValue = null;
		if (!barcodeScanValue) return;

		let barcodeScannedValueFound = false;
		try {
			scannedValue = util.parseBarcode(barcodeScanValue);
			barcodeScannedValueFound = true;
		} catch (e) {
			barcodeScannedValueFound = false;
		}

		if (!barcodeScannedValueFound) {
			Swal.fire({ titleText: strings.ErrorTitle, text: strings.BarcodeFormat, icon: 'error', confirmButtonText: strings.Ok, allowOutsideClick: false });
			return false;
		}

		if (barcodeScannedValueFound) {
			const aiValues = scannedValue.parsedCodeItems;
			let gTinNo = aiValues.filter(function (e) { return e.ai === consts.BarcodeApplicationIdentifier.TinNo; });
			if (gTinNo.length > 0) {
				gtnValue = gTinNo[0].data.slice(2, -1);
			}
			const lotOrBatchNo = aiValues.filter((e) => e.ai === consts.BarcodeApplicationIdentifier.LotOrBatchNo);
			const expiryDate = aiValues.filter((e) => e.ai === consts.BarcodeApplicationIdentifier.ExpiryDate);
			if (lotOrBatchNo.length > 0) {
				lotNumber = lotOrBatchNo[0].data;
			}

			const formData = new FormData();
			formData.append('action', 'otherAction');
			formData.append('otherAction', 'GetBarcode');
			formData.append('barcode', barcodeScanValue);
			formData.append('lotNumber', lotNumber);
			fetch(connectionService.Indicator, { method: 'POST', body: formData })
			.then(response => {
				response.text().then(function (text) {
					const responseData = JSON.parse(text);
					if (responseData.data && responseData.data.length !== 0) {
						if ([consts.IndicatorType.CI, consts.IndicatorType.BI].includes(responseData.data[0].TypeId) && responseData.data[0].IsActive) {
							if (responseData.data[0].IncubatorCycleDetailCount === 0 || window.location.hash.includes('incubatorcycledetailform')) {
								if (expiryDate.length > 0) {
									const configExpiredDate = new Date(new Date().setDate(new Date().getDate() - util.checkConfigData('BIExpiredDaysAccess')));
									const newExpiryDate = expiryDate[0].data;

									if (configExpiredDate > newExpiryDate) {
										const isChemicalIndicator = responseData.data[0].TypeId === consts.IndicatorType.CI;
										const infoMsg = isChemicalIndicator ? strings.ExpiredCI : strings.ExpiredBI;
										Swal.fire({ titleText: strings.Info, text: infoMsg, icon: 'info', confirmButtonText: strings.Ok, allowOutsideClick: false });
									} else {
										if (new Date() > newExpiryDate) {
											Swal.fire({
												titleText: 'Are you sure?',
												text: strings.BIExpired,
												icon: 'warning',
												showCancelButton: true,
												confirmButtonClass: 'btn-danger',
												confirmButtonText: strings.Yes,
												cancelButtonText: strings.No,
												closeOnConfirm: true,
												closeOnCancel: true,
												allowOutsideClick: false,
											}).then(({ isConfirmed }) => {
												if (isConfirmed) {
													navigate(`/incubatorcycledetailform?id=${id}&attachmentCount=${0}&cycleId=${cycleId}&incubatorCycleId=${incubatorCycleId}&incubatorId=${incubatorId}&isError=false&isFromCycle=true&gTIN=${barcodeScanValue}&returnTo=${encodeURIComponent(`/cyclelist`)}`, { state: { ...responseData.data[0], isFromScanBarcode: true, previousPath: location.pathname, ...location } });
												}
											});
										} else {
											navigate(`/incubatorcycledetailform?id=${id}&attachmentCount=${0}&cycleId=${cycleId}&incubatorCycleId=${incubatorCycleId}&incubatorId=${incubatorId}&isError=false&isFromCycle=true&gTIN=${barcodeScanValue}&returnTo=${encodeURIComponent(`/cyclelist`)}`, { state: { ...responseData.data[0], isFromScanBarcode: true, previousPath: location.pathname, ...location } });
										}
									}
								} else {
									Swal.fire({ titleText: strings.ErrorTitle, text: strings.BarcodeFormat, icon: 'error', confirmButtonText: strings.Ok, allowOutsideClick: false });
								}
							} else {
								setState({ ...state, lotNumber: lotNumber, openPopUp: true, seletedRow: {} });
							}
						} else {
							navigate(`/lotdetaillist?id=${responseData.data[0].LotDetailId}`);
						}
					} else {
						navigate(`/lotdetaillist?id=0&Barcode=${barcodeScanValue}&LotNumber=${lotNumber}&GTIN=${gtnValue}&ExpiryDate=${dayjs(expiryDate[0]?.data).format(consts.MomentFormat.DateTimeFormat)}&returnTo=${encodeURIComponent('/lotdetaillist')}`);
					}
				});
			});
		}
	};

	const hideModal = () => {
		setState({ ...state, openPopUp: false });
	};


	const onProcess = (e) => {
		if (state.seletedRow) {
			const bIResult = state.seletedRow.BIResult || 0;
			navigate(`/incubatorcycledetailform?id=${state.seletedRow.IncubatorCycleDetailId || 0}&attachmentCount=${state.seletedRow?.AttachmentCount || 0}&cycleId=${state.seletedRow?.CycleId || 0}&incubatorCycleId=${state.seletedRow?.IncubatorCycleId || 0}&isError=${bIResult === consts.BIResult.Error}&isFromCycle=${false}&returnTo=${encodeURIComponent(`/cyclelist`)}`);
			hideModal();
		}
	};

	return (
		<Box className="no-print">
			<Box>
				<AppBar position="fixed" sx={{ background: '#205080' }}>
					<Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
						<Box sx={{ display: 'flex', alignItems: 'center' }}>
							<img src={connectassurePng} alt="Connect Assure Logo" />
							<br />
						</Box>
						<Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', textAlign: 'center' }}>
							<img
								className="center-block img-responsive"
								style={{
									padding: '0em .7em',
									borderRadius: '.3em',
									background: 'white',
									maxHeight: '3.8em'
								}}
								src={hospitalLogo || STERISLogoPng}
								alt="Hospital or STERIS Logo"
							/>
							<Box>{loginData?.HospitalName}</Box>
						</Box>
						<Box sx={{ display: 'flex', alignItems: 'center' }} component="form" onSubmit={(e) => e.preventDefault()}>
							{isCatViewer && !isAdminOrViewer && (
								<TextField
									variant="outlined"
									size="small"
									name="header-barcode"
									type="text"
									className=" no-print"
									placeholder={strings.Scan}
									onChange={debounce(300, onGTINChange)}
									autoFocus={false}
									inputProps={{ autoComplete: "new-password" }}
									margin="dense"
									sx={{
										'& .MuiInputBase-root': {
											backgroundColor: 'background.paper'
										}
									}}
									autoComplete="off"
								/>
							)}
							<IconButton
								className="no-print"
								title={strings.Logout}
								onClick={logoutUser}
								sx={{ color: 'background.paper' }}
							>
								<LogoutIcon fontSize="inherit" />
							</IconButton>
						</Box>
					</Toolbar>
				</AppBar>
				<Box sx={{ height: 40 }}></Box>

				<Dialog
					open={state.openPopUp}
					onClose={hideModal}
					fullScreen={fullScreen} // Use fullScreen for small screens
					maxWidth="md" // Set your desired max width
					fullWidth
					sx={{ marginTop: '50px' }}
				>
					<DialogTitle sx={{ color: 'primary.main' }}>{strings.PendingBI}</DialogTitle>
					<DialogContent>
						<IncubatorCycleDetailTable
							scope={state}
							disableLoadPref={true}
							disableShowHideColumns={true}
							enableFilter={false}
							disableExport={false}
							isForIncubator={true}
							disabledDoubleClick={true}
							title={strings.PendingBI}
							disablePreferences={true}
							disableFiltering={true}
							dataProperty="incubatorCycleDetailPendingList"
							disableAdd={true}
							listAction={listIncubatorCycleDetailPending}
							onSelection={(id, { row: record }) => {
								setState({ ...state, seletedRow: record });
							}}
							onOpenForm={({ id }) => {
								setState({ ...state, openPopUp: false })
								if (!id) {
									navigate(`/incubatorcycledetailform?id=${0}&attachmentCount=${0}&cycleId=${0}&incubatorCycleId=${0}&isError=false&isFromCycle=false&gTIN=0&returnTo=/cyclelist`);
								}
							}}
							parentFilters={{
								filter: [
									{ operator: '$eq', value: 0, property: 'IsAcknowledge', type: 'boolean' },
									{ operator: 'like', value: `%${state.lotNumber}`, property: 'LotNumber', type: 'string' }
								]
							}}
						/>
					</DialogContent>
					<DialogActions>
						<Button onClick={onProcess} variant="contained" color="primary">
							{strings.Process}
						</Button>
						<Button onClick={hideModal} variant="contained" color="warning">
							{strings.Cancel}
						</Button>
					</DialogActions>
				</Dialog>
			</Box>
		</Box>
	);
}



export default TopHeader;
